import { LiliTransaction } from '../types/lili-transaction';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import { TransactionAllowCategorizationEnum } from '../enum/transaction-allow-categorization';
import { TransactionCategorizationType } from '../enum/transaction-categorization-type';

export interface CategorizationColumnInfo {
  canCategorize: boolean
  isBusiness: boolean | null
  canEdit: boolean
  canConfirm: boolean
  selectedCategoryId?: string | null
  suggestedCategoryId?: string | null
}

const initialCategorizationColumnInfo: CategorizationColumnInfo = {
  canCategorize: false,
  isBusiness: false,
  canEdit: false,
  canConfirm: false,
  selectedCategoryId: null,
  suggestedCategoryId: null,
};

export function isCategorizedAsBusiness(t: LiliTransaction) : boolean {
  return (t.categoryDetails?.businessPercent || 0) > 0;
}

export function isCategorized(t: LiliTransaction) : boolean {
  return t.categoryDetails?.businessPercent !== null && t.categoryDetails?.businessPercent !== undefined;
}

export function isSuggestedCategoryAvailable(t: LiliTransaction): boolean {
  return !!t.suggestedTaxCategoryId;
}

export function canBeCategorizedRegardlessFeatureFlag(t: LiliTransaction) : boolean {
  return t.allowCategorizationEnum === TransactionAllowCategorizationEnum.READ_WRITE;
}

export function canBeCategorized(t: LiliTransaction) : boolean {
  if (canBeCategorizedRegardlessFeatureFlag(t) && validateFeatureFlag(FEATURE_FLAG.CATEGORIZATION.FEATURE)) {
    if (t.categorizationType === TransactionCategorizationType.INCOME) {
      return validateFeatureFlag(FEATURE_FLAG.CATEGORIZATION.INCOME);
    }
    return true;
  }
  return false;
}

export function dataForTransactionCategorizationColumn(t: LiliTransaction): CategorizationColumnInfo {
  if (!canBeCategorized(t)) {
    return {
      ...initialCategorizationColumnInfo,
      canCategorize: false,
    };
  }

  if (isCategorized(t)) {
    return {
      canCategorize: false,
      isBusiness: isCategorizedAsBusiness(t),
      selectedCategoryId: t.categoryDetails?.categoryExternalId,
      suggestedCategoryId: null,
      canEdit: false,
      canConfirm: false,
    };
  }
  return {
    canCategorize: true,
    isBusiness: null,
    selectedCategoryId: null,
    suggestedCategoryId: t.suggestedTaxCategoryId,
    canEdit: true,
    canConfirm: t.suggestedTaxCategoryId != null,
  };
}

export function isCategorizedMostlyAsBusiness(t: LiliTransaction) : boolean {
  return (t.categoryDetails?.businessPercent || 0) > 0.5;
}

export function isCategorizedOnlyAsBusiness(t: LiliTransaction) : boolean {
  return (t.categoryDetails?.businessPercent || 0) === 1;
}

export function isCategorizedAsSplitted(t: LiliTransaction) : boolean {
  return isCategorizedAsBusiness(t) && !isCategorizedOnlyAsBusiness(t);
}

export function canAttachReceipt(t: LiliTransaction) : boolean {
  return canBeCategorized(t);
}

export function hasReceipt(t: LiliTransaction) : boolean {
  return t.receiptKey != null;
}

export function hasNote(t: LiliTransaction) : boolean {
  return t.comment != null;
}
